import { Temporal } from './temporal';

/** Check if an instant is in the past (replaces `new Date() > expiresAt`) */
export function isExpired(instant: Temporal.Instant): boolean {
  return Temporal.Instant.compare(Temporal.Now.instant(), instant) > 0;
}

/** Check if a plain date is in the past */
export function isPastDate(date: Temporal.PlainDate): boolean {
  return Temporal.PlainDate.compare(date, Temporal.Now.plainDateISO()) < 0;
}

/** Check if a plain date is today */
export function isToday(date: Temporal.PlainDate): boolean {
  return Temporal.PlainDate.compare(date, Temporal.Now.plainDateISO()) === 0;
}

/** Check if a plain date is yesterday */
export function isYesterday(date: Temporal.PlainDate): boolean {
  const yesterday = Temporal.Now.plainDateISO().subtract({ days: 1 });
  return Temporal.PlainDate.compare(date, yesterday) === 0;
}

/** Check if a plain date is in the future */
export function isFutureDate(date: Temporal.PlainDate): boolean {
  return Temporal.PlainDate.compare(date, Temporal.Now.plainDateISO()) > 0;
}

/** Absolute number of days between two plain dates */
export function daysBetween(a: Temporal.PlainDate, b: Temporal.PlainDate): number {
  return Math.abs(a.until(b, { largestUnit: 'day' }).days);
}

/** Signed number of days from `from` to `to` (positive = `to` is later) */
export function daysUntil(from: Temporal.PlainDate, to: Temporal.PlainDate): number {
  return from.until(to, { largestUnit: 'day' }).days;
}
